import { func, number, string } from "prop-types";
import { PriceFormats } from "@repo/utils";
import { MAX_VALUES } from "@utils";
import { useEstimateStructure } from "@tools";
import { ClearInput } from "@components";

export const FixedPriceInput = ({
  value,
  prefix,
  onChange,
}) => {
  const structure = useEstimateStructure();
  
  const { currencyObj, priceFormat } = structure.settings;
  
  return (
    
    <ClearInput
      confirmOnEnter={false}
      name="fixed amount"
      value={value}
      onChange={onChange}
      max={MAX_VALUES.PRICE}
      min={0}
      prefix={`${prefix || ""}${currencyObj.symbolStart || ""}`}
      suffix={currencyObj.symbolEnd}
      applySuffixSpacing
      addInitialBorder
      decimals={2}
      showDecimals
      fullWidth
      className="w-half"
      
      americanFormat={priceFormat === PriceFormats.AMERICAN}
    />
  )
}

FixedPriceInput.propTypes = {
  onChange: func.isRequired,
  value: number,
  prefix: string,
}